module.exports = __webpack_public_path__ + "static/media/daily.b12110de.svg";